import { useEffect } from "react";

const InstagramFeed = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://elfsightcdn.com/platform.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="elfsight-app-1f2d4041-b349-47ae-b9c1-b8cd16286e00" data-elfsight-app-lazy></div>
  );
};

export default InstagramFeed;
